import React from "react";
import arrowImg from "./assets/arrow.svg";

function VerticalStepper({ stepTitles, currentStep, onStepClick }) {
  return (
    <div className="shadow"
     style={{
  display: "flex",
  justifyContent: "center",
  margin: "2rem auto",
  maxWidth: "1200px",
  padding: "30px 0",
  marginTop: "30px"
}}
    >
      {stepTitles.map((title, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center" }}>
          <div
            //onClick={() => onStepClick(index)}
            style={{
              margin: "0 10px",
              padding: "16px 20px",
              cursor: "pointer",
              borderRadius: "8px",
              border:
                currentStep === index ? "1px solid gray" : "1px solid #dedede",
              color: currentStep === index ? "gray" : "#dedede",
            }}
          >
            {title}
          </div>
          {index < stepTitles.length - 1 && (
            <div className="arrowImage">
              <img src={arrowImg} alt="arrow" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default VerticalStepper;
